import React from "react";

const ReturnPolicy = () => {
  return (
    <div className="container mx-auto p-6">
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">
          Return & Refund Policy
        </h2>

        <p className="mb-4">
          We want your experience with <strong>Daga Gems</strong> to be exceptional, and we stand behind the quality of our products.
        </p>

        {/* Return & Refund */}
        <h3 className="text-xl font-semibold mt-6 mb-2">Return & Refund</h3>
        <p className="mb-4">
          If you receive a damaged product or if the seal is open, you are eligible for returns and a 100% refund. 
          Please ensure that the product is returned within 3 days of delivery.
        </p>

        {/* Defective Products */}
        <h3 className="text-xl font-semibold mt-6 mb-2">Defective Products</h3>
        <p className="mb-4">
          For defective products, image verification is required. Please contact customer care with pictures of the issue.
        </p>

        {/* Video Confirmation */}
        <h3 className="text-xl font-semibold mt-6 mb-2">Video Confirmation</h3>
        <p className="mb-4">
          It is mandatory to record a video during product delivery to avoid disputes during returns.
        </p>

        {/* Incorrect Product */}
        <h3 className="text-xl font-semibold mt-6 mb-2">Incorrect or Changed Product</h3>
        <p className="mb-4">
          If you receive an incorrect or changed product, you must provide the delivery video as proof.
        </p>

        {/* Refund Procedure */}
        <h3 className="text-xl font-semibold mt-6 mb-2">Refund Procedure</h3>
        <p className="mb-4">
          Refunds will be processed to the original payment method within 2-3 working days after quality inspection.
        </p>

        {/* Non-Eligible Products */}
        <h3 className="text-xl font-semibold mt-6 mb-2">
          Non-Eligible Products for Return & Replacement
        </h3>
        <ul className="list-disc list-inside space-y-2">
          <li>Products showing physical damage</li>
          <li>Used products</li>
          <li>Products not in original condition</li>
          <li>Missing certificate, invoice, or packaging</li>
          <li>Return shipping cost is borne by the customer</li>
          <li>Engraved or personalized products</li>
          <li>Solitaire items</li>
          <li>Gold and silver items (only eligible for buyback)</li>
        </ul>

        {/* How to Process */}
        <h3 className="text-xl font-semibold mt-6 mb-2">
          How to Process a Return
        </h3>
        <ol className="list-decimal list-inside space-y-2">
          <li>Select the item you want to return</li>
          <li>Pack it with original materials and certificate</li>
          <li>Keep proof of return (receipt, tracking, or SMS)</li>
          <li>
            Refund will be processed within 2-3 working days after inspection
          </li>
        </ol>

        {/* Exchange Policy */}
        <h3 className="text-xl font-semibold mt-6 mb-2">Exchange Policy</h3>
        <p className="mb-4">
          Products can be exchanged based on current market value with deductions for making charges and a ₹500 processing fee. 
          Credits are valid for 365 days and cannot be converted to cash.
        </p>

        {/* Buyback Policy */}
        <h3 className="text-xl font-semibold mt-6 mb-2">Buyback Policy</h3>
        <p className="mb-4">
          Buyback value will be transferred via bank transfer within 10 days after inspection. Altered jewelry will not be accepted.
        </p>

        {/* Incorrect Product */}
        <h3 className="text-xl font-semibold mt-6 mb-2">
          Incorrect Product Received
        </h3>
        <p className="mb-4">
          Report within 3 days to receive a full refund. Return shipping will be covered by Daga Gems.
        </p>

        {/* Return Process */}
        <h3 className="text-xl font-semibold mt-6 mb-2">
          Return Process & Payment
        </h3>
        <ul className="list-disc list-inside space-y-2">
          <li>Do not accept delivery if seal is broken</li>
          <li>Shipping charges may be deducted if not free shipping</li>
          <li>Refunds processed via original payment method</li>
          <li>COD refunds transferred to bank account</li>
          <li>Refund timeline: within 14 days after inspection</li>
        </ul>

        {/* Modification */}
        <h3 className="text-xl font-semibold mt-6 mb-2">Modification</h3>
        <p className="mb-4">
          Daga Gems reserves the right to modify these terms without prior notice.
        </p>

        {/* Resizing */}
        <h3 className="text-xl font-semibold mt-6 mb-2">
          Resizing and Repairing Policy
        </h3>
        <ul className="list-disc list-inside space-y-2">
          <li>Additional material during resizing is chargeable</li>
          <li>No responsibility for existing damage</li>
          <li>Resized/repaired items are non-refundable</li>
          <li>Does not include remaking jewelry</li>
        </ul>
      </section>
    </div>
  );
};

export default ReturnPolicy;